import { useQuery, useQueryClient } from '@tanstack/react-query'
import React from 'react'
import { listComparables as listComparablesAPI} from 'services/apiComparable';

const useListComparable = (page=1,size=10,orderId) => {

  const queryClient = useQueryClient();
  console.log("useListComparable is using key:", ['compList', page, size, orderId]);
  const{isPending, isSuccess, isError, error, data,refetch} = useQuery({
    queryKey:   ['compList',page,size,orderId],
    queryFn:()=> listComparablesAPI(page,size,orderId),
    keepPreviousData:false,
    // staleTime: 2 * 60 * 60 * 1000,
    enabled: !!orderId
  })

  return{isPending, isSuccess, isError, error, data,refetch}
}

export default useListComparable